// This function checks the due date of employee content and 
// updates the UI accordingly on the content card

export function checkDueDate() {
    const card = document.querySelector(".th-content-card");

    if (!card) return;

    const dueDateString = card.dataset.dueDate; // format: MMM DD, YYYY
    if (!dueDateString) return;

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const now = new Date().toLocaleString("en-US", { timeZone: userTimeZone });
    const nowDate = new Date(now);

    const parsedDueDate = new Date(dueDateString);
    const dueAtMidnight = new Date(
        new Date(parsedDueDate.toLocaleString("en-US", { timeZone: userTimeZone }))
        .setHours(0, 0, 0, 0)
    );
    dueAtMidnight.setDate(dueAtMidnight.getDate() + 1); // Midnight after the due date

    const dateElement = card.querySelector(".th-content-card_due-date");
    if (!dateElement) return;

    const labelDue = card.dataset.dueLabel || "";
    const labelPastDue = card.dataset.pastDueLabel || "";

    if (!labelDue && !labelPastDue) return;

    if (nowDate >= dueAtMidnight) {
      dateElement.classList.add("th-content-card_badge--past-due");
      dateElement.textContent = `${labelPastDue}`;
    } else {
      dateElement.textContent = `${labelDue}`;
    }
}
